<app-loader [isLoading]="isLoading"></app-loader>
@if(isEditDatePage){
<router-outlet></router-outlet>
}@else {
<div class="header">
  <app-title [title]="title" [subtitle]="subtitle"></app-title>
  <!-- @if(myroles.can_write){ -->
  <div class="top cook-screen">
    <div class="boton">
      <button class="b1" mat-button (click)="refreshReservations()">
        Refrescar reservas
      </button>
      <button class="b1" mat-button (click)="goToAddReservation()">
        Consumir menú
      </button>
    </div>
  </div>
  <!-- } -->
</div>
<div class="content">
  <div class="filter">
    <div class="search-section">
      <mat-form-field appearance="outline">
        <mat-label>Buscar trabajador</mat-label>
        <mat-icon matTextPrefix style="position: relative; top: +0.33em">search</mat-icon>
        <input matInput type="search" (input)="onSearchChange($event)" />
      </mat-form-field>
    </div>
    <div class="paginator-container">
      <mat-paginator [pageSizeOptions]="[50, 100]" aria-label="Select page of workers table" class="paginator-field">
      </mat-paginator>
    </div>
  </div>
  <div class="cards">
    <app-restaurant-summary-cards [cards]="summaryCards" layout="grid"></app-restaurant-summary-cards>
  </div>
  <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)"
    class="mat-elevation-z8 table">
    >

    <!-- Columna de Usuarios -->
    <ng-container matColumnDef="users">
      <th mat-header-cell *matHeaderCellDef>USUARIO</th>
      <td mat-cell *matCellDef="let element">
        <span style="font-size: 16px">
          {{ element.employee_name | qeqPipe }}
        </span>
      </td>
    </ng-container>

    <!-- Columna de Id Usuario -->
    <ng-container matColumnDef="id-users">
      <th mat-header-cell *matHeaderCellDef>ID EMPLEADO</th>
      <td mat-cell *matCellDef="let element">
        <span style="font-size: 16px">{{ element.employee_external_id }}</span>
      </td>
    </ng-container>

    <!-- Columna de Fecha -->
    <ng-container matColumnDef="diet-date">
      <th mat-header-cell *matHeaderCellDef>FECHA RESERVA</th>
      <td mat-cell *matCellDef="let element">
        <span style="font-size: 16px">{{ element.date }}</span>
      </td>
    </ng-container>

    <!-- Columna de Consumos -->
    <ng-container matColumnDef="consumed">
      <th mat-header-cell *matHeaderCellDef>CONSUMOS</th>
      <td mat-cell *matCellDef="let element">
        @if(element.meal_type != 'BREAKFAST'){
        <button mat-flat-button id="button">
          <span style="font-size: 16px">Comida</span>
        </button>

        }@else{
        <button mat-flat-button id="button">
          <span style="font-size: 16px">Desayuno</span>
        </button>
        }
      </td>
    </ng-container>

    <!-- Columna de Estado -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="status">ESTADO</th>
      <td mat-cell *matCellDef="let element">
        @if(element.status === 'EATEN'){
        <button mat-flat-button id="consumed">
          <mat-icon matTextPrefix>check_circle</mat-icon>
          <span style="font-size: 16px">Consumido</span>
        </button>
        }@else if (element.status === 'PENDING') {
        <button mat-flat-button id="reservation">
          <mat-icon matTextPrefix>pending</mat-icon>
          <span style="font-size: 16px">Reserva</span>
        </button>
        }@else {
        <button mat-flat-button id="non-consumed">
          <mat-icon matTextPrefix>cancel</mat-icon>
          <span style="font-size: 16px">No consumido</span>
        </button>
        }
      </td>
    </ng-container>

    <!-- Columna de invitados -->
    <ng-container matColumnDef="guests">
      <th mat-header-cell *matHeaderCellDef>INVITADOS</th>
      <td mat-cell *matCellDef="let element">
        <button mat-flat-button id="button">
          <span style="font-size: 16px">{{ element.guests_number }}</span>
        </button>
      </td>
    </ng-container>

    <!-- Columna de celiac -->
    <ng-container matColumnDef="celiac">
      <th mat-header-cell *matHeaderCellDef>CELÍACO</th>
      <td mat-cell *matCellDef="let element">
        @if(element.is_celiac){
        <button mat-flat-button class="celiac" id="button">
          <span style="font-size: 16px">Sí</span>
        </button>

        }@else{
        <button mat-flat-button id="button">
          <span style="font-size: 16px">No</span>
        </button>
        }
      </td>
    </ng-container>


    <!-- Columna de sincronizado -->
    <ng-container matColumnDef="source">
      <th mat-header-cell *matHeaderCellDef>CON RESERVA</th>
      <td mat-cell *matCellDef="let element">
        @if(element.has_reservation){
        <button mat-flat-button class="celiac" id="button">
          <span style="font-size: 16px">Sí</span>
        </button>
        }@else{
        <button mat-flat-button id="button">
          <span style="font-size: 16px">No</span>
        </button>
        }
      </td>
    </ng-container>

    <!-- Columna de Acciones -->
    <ng-container matColumnDef="acciones">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        @if(element.has_reservation && element.reservation_id && element.status === 'PENDING'){
        <button mat-icon-button class="acciones" (click)="viewDetails(element.reservation_id)">
          <mat-icon svgIcon="edit"></mat-icon>
        </button>
        }
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
}